import { lodging, narrative, place, poi, } from "@lonelyplanet/open-planet-node/dist/openPlanetTypes";
import { opTypeMapping } from "./opTypeMapping";
/**
 * Get the category label for a search result
 * @param result {ISearch} The search result
 */
var getResultCategory = function (result) {
    var opType = result.opType, parentName = result.parentName, subtype = result.subtype, title = result.title;
    if (parentName) {
        if (subtype && (opType === poi || opType === lodging)) {
            return parentName + " " + subtype;
        }
        else if (opType === narrative || opType === "narratives") {
            return parentName + " in detail";
        }
        else if (opType === place || opType === "poi-list") {
            return parentName;
        }
        else if (opTypeMapping[opType]) {
            return parentName + " " + opTypeMapping[opType];
        }
    }
    else if (opType !== "unknown" && opType) {
        return subtype || opTypeMapping[opType] || "";
    }
    return "";
};
export default getResultCategory;



//////////////////
// WEBPACK FOOTER
// ./app/modules/search/utils/getResultCategory.ts
// module id = nYNN
// module chunks = 2